import React from 'react'
import isNull from '../../../../utils/NullChecking'
import { useSelector } from 'react-redux'
import { FindSecondChild } from '../../../../utils/FindMenuOption'

const BillingRightMenu = ({ EndMenuItems, handleChangeMenuOptions, handleSaveRoles, RoleID, handleSelectAll, SelectAll, activeMenuName, getMenuIconClass, isViewAll, isAddAll, isDeleteAll }) => {
    let IsEditAllowed = FindSecondChild('Setup', 'User Management', 'Roles')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'User Management', 'Roles')?.IsDeleted

    return (
        <div className='ar_box-content p-2'>
            <div className='d-flex align-items-center gap-6 top_heading mb-06-px'>
                <i className={`${getMenuIconClass(activeMenuName)}`}></i>
                <p className="heading fs-13 lh-13">{activeMenuName}</p>
            </div>
            <div className="main-content  px-0 pb-0">
                <div className="d-flex flex-column gap-15">
                    <div className="d-flex justify-content-between align-items-center px-10">
                        <p className='mb-3 pb-2px'></p>
                        <div className="d-flex align-items-center gap-74">
                            <div className="ar-width">
                                <p className="heading">View</p>
                            </div>

                            <div className="ar-width">
                                <p className="heading">Add/Edit</p>
                            </div>

                            <div className="ar-width">
                                <p className="heading">Delete</p>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center br-bottom-1 pb-1-5 za_br_light mx-10">
                        <p className='heading orange-drk'>Select All</p>
                        <div className="d-flex align-items-center gap-74">
                            <div className="ar-width">
                                <label className="custom_check_box d-flex">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name="ISView"
                                        id="ISView"
                                        onChange={(e) => handleSelectAll(e, 'ISView')}
                                        checked={isViewAll}
                                    />
                                </label>
                            </div>
                            <div className="ar-width">
                                <label className="custom_check_box d-flex">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name="IsAdd"
                                        id="IsAdd"
                                        onChange={(e) => handleSelectAll(e, 'IsAdd')}
                                        checked={isAddAll}
                                    />
                                </label>
                            </div>
                            <div className="ar-width">
                                <label className="custom_check_box d-flex">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name="IsDeleted"
                                        id="IsDeleted"
                                        onChange={(e) => handleSelectAll(e, 'IsDeleted')}
                                        checked={isDeleteAll}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-15 px-10 scroll-content hover-scrollbar">
                        {EndMenuItems && EndMenuItems.map((item, index) => {
                            return (
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className='text lh-14'>{item.MenuName}</p>
                                    <div className="d-flex align-items-center gap-74">
                                        {item.IsViewConfigured ?
                                            <div className="ar-width">
                                                <label className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="ISView"
                                                        id="ISView"
                                                        checked={item.ISView}
                                                        onChange={(e) => handleChangeMenuOptions(e, item, index)}
                                                    />
                                                </label>
                                            </div> : <div className="ar-width empty">
                                            </div>
                                        }
                                        {item.IsAddConfigured ?
                                            <div className="ar-width">
                                                <label className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="IsAdd"
                                                        id="IsAdd"
                                                        checked={item.IsAdd}
                                                        onChange={(e) => handleChangeMenuOptions(e, item, index)}
                                                    />
                                                </label>
                                            </div> : <div className="ar-width empty">
                                            </div>}
                                        {item.IsDeletedConfigured ?
                                            <div className="ar-width">
                                                <label className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        name="IsDeleted"
                                                        id="IsDeleted"
                                                        checked={item.IsDeleted}
                                                        onChange={(e) => handleChangeMenuOptions(e, item, index)}
                                                    />
                                                </label>
                                            </div> : <div className="ar-width empty">
                                            </div>}

                                        {/* <div className="ar-width empty">
                                        </div> */}

                                    </div>

                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BillingRightMenu